import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';

import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import { fetchEmpAttendanceReg } from '../../../Store/PHPSlice/Employee';
import { selectEmpAttendanceReg } from '../../Selectors/Master/MasterSelectors';



const EmpAttendanceView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const empatlist = useSelector(selectEmpAttendanceReg);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchEmpAttendanceReg(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (empatlist?.data) {
            setFormData(empatlist?.data);
        }
    }, [empatlist]);

    // console.log(formData);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // console.log(empatlist)

    const tableHeadArray = ["Date", "In1", "Out1", "In2", "Out2", "In3", "Out3", "In4", "Out4", "Working Hrs", "Extra Hrs", "Schedule Type"];

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {/* {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />} */}
                        <h3 className='centered-heading'>Employee Attendance View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Entry Date</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.entrydt}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>From & To Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.fromdt} & {formData.todt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Punching Id</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }} className='light-color'>{formData.punchId}</td>
                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>Total Days</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totdays}</td>
                                    <td style={{ width: '200px' }}>Present Days</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.present_days}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Leave Days</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.leave_days}</td>
                                    <td style={{ width: '200px' }}>Per Hour Pay</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.perHr_pay}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Total Work Hours</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totwork_hr}</td>
                                    <td style={{ width: '200px' }} className='dark-color'>Payable Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='dark-color'>{formData.payamt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Total Extra Work Hours</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.extra_hr}</td>
                                    {/* <td style={{ width: '200px' }} className='dark-color'>Payable Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='dark-color'>{formData.payamt}</td> */}
                                </tr>

                            </tbody>
                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {
                                            tableHeadArray?.map((item, index) => (
                                                <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center' key={index}>
                                                    {item}
                                                </TableCell>
                                            ))
                                        }

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {empatlist?.info?.map((row, index) => (
                                        <TableRow key={index}>

                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.date}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.in1}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.out1}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.in2}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.out2}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.in3}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.out3}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.in4}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.out4}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.tothrs}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.exthrs}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.schedule_type}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>

                </Paper>
            </Grid >
        </>
    );
};

export default EmpAttendanceView;
